import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const socket = io(SOCKET_URL, {
  // Prioritize pure WebSocket to avoid HTTP long-polling session invalidation ("Session ID unknown")
  transports: ["websocket", "polling"],
  upgrade: true,
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
});

// Auto-recover cleanly if the server restarts or invalidates an in-memory session ID
socket.on("connect_error", (error) => {
  if (error && error.message && error.message.includes("Session ID unknown")) {
    console.warn("Socket session expired or unknown. Resetting connection...");
    socket.connect();
  }
});

export default socket;
